export const isVfpr = window.location.hostname.match(
  /^propertyscape-reg(?:\.\w+)?\.deckard.com$/,
);

export const MAIN_REG_URL  = "https://str.deckard.com";
export const FORECLOUSRES_REG_URL ="https://propertyscape-reg.deckard.com";
